import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AnalyticIdentify } from "@/features/my/_providers/analytic-identify";
import { CheckRoleProvider } from "@/features/my/_providers/check-role-provider";
import { PageViewTrackingProvider } from "@/features/my/_providers/page-view-tracking-provider";
import { PresaleAccessGate } from "@/features/my/_providers/presale-access-gate";
import { ProtectedProvider } from "@/features/my/_providers/protected-provider";
import { SupportChatIdentify } from "@/features/my/_providers/support-chat-identify";

export const Route = createFileRoute("/(member)/(protected)")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ProtectedProvider>
      <PresaleAccessGate>
        <CheckRoleProvider>
          <SupportChatIdentify>
            <AnalyticIdentify>
              <PageViewTrackingProvider>
                <Outlet />
              </PageViewTrackingProvider>
            </AnalyticIdentify>
          </SupportChatIdentify>
        </CheckRoleProvider>
      </PresaleAccessGate>
    </ProtectedProvider>
  );
}
